import { crudGetList } from 'react-admin';
import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';

import { history } from './../App';
import {
  deleteTeamMember,
  disableIdentity,
  enableIdentity,
  force2FA,
  reset2FA,
  resetPassword,
} from '~/api/team';
import { crudGetOne } from 'react-admin';

export const useDeleteTeamMember = () => {
  const dispatch = useDispatch();

  return useMutation(deleteTeamMember, {
    onSuccess() {
      dispatch(crudGetList('team', { page: 1, perPage: 25 }, { field: 'id', order: 'DESC' }, {}));
      history.push('/team?page=1');
    },
  });
};

export const useReset2FA = (id: any) => {
  const dispatch = useDispatch();

  return useMutation(reset2FA, {
    onSuccess() {
      dispatch(crudGetOne('team', id, '/team'));
    },
  });
};

export const useForce2FA = (id: any) => {
  const dispatch = useDispatch();

  return useMutation(force2FA, {
    onSuccess() {
      dispatch(crudGetOne('team', id, '/team'));
    },
  });
};

export const useEnableIdentity = (id: any) => {
  const dispatch = useDispatch();

  return useMutation(enableIdentity, {
    onSuccess() {
      dispatch(crudGetOne('team', id, '/team'));
    },
  });
};

export const useDisableIdentity = (id: any) => {
  const dispatch = useDispatch();

  return useMutation(disableIdentity, {
    onSuccess() {
      dispatch(crudGetOne('team', id, '/team'));
    },
  });
};

export const useResetPassword = () => {
  return useMutation(resetPassword, {
    onSuccess() {},
  });
};
